import { baseBUCGet } from '../base/baseBUC';

export const condominiumBoardElectionDetailModelGet = ({ condominiumBoardElectionId = '', buildingId = '', userId = '', userElectionId = '', condominiumBoardRoleId = '', }) => {
    return {
        condominiumBoardElectionId: condominiumBoardElectionId,
        userElectionId: userElectionId,
        condominiumBoardRoleId: condominiumBoardRoleId,
        isFinalSelected: false,
        votes: [],
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};